import React, { useEffect, useRef, useState } from "react";

const SUPPORT_EMAIL = "support@fodxpert.com";
const SUPPORT_PHONE = "+91-9999999999";

/**
 * Floating contact button shown on the brand login screen and throughout the
 * brand portal, since brand users have no other way to reach FodXpert support.
 */
const ContactFodxpert: React.FC = () => {
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50" ref={panelRef}>
      {open && (
        <div className="absolute bottom-16 right-0 w-64 bg-white border border-gray-200 rounded-xl shadow-lg p-4 animate-fade-in-up">
          <p className="text-sm font-semibold text-gray-900 mb-3">
            Contact FodXpert
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="block text-sm text-gray-700 hover:bg-gray-100 rounded px-3 py-2 transition-colors"
          >
            {SUPPORT_EMAIL}
          </a>
          <a
            href={`tel:${SUPPORT_PHONE}`}
            className="block text-sm text-gray-700 hover:bg-gray-100 rounded px-3 py-2 transition-colors"
          >
            {SUPPORT_PHONE}
          </a>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Contact FodXpert"
        className="h-12 w-12 rounded-full bg-primary-default text-white flex items-center justify-center shadow-lg hover:opacity-90 transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      </button>
    </div>
  );
};

export default ContactFodxpert;
